export const DEFAULT_BASE_URL = "/evt.gif";
export const SECTION_TRACKING_BASE_URL = "/t.gif";
